import axios from "axios";

const urlPath = "almacenKae";

export const createAlmacen = async (data) => {
  try {
    const response = await axios.post(urlPath, data);

    return response;
  } catch (err) {
    console.log(err);
    return(err);
  }
};

export const getAlmacenes = async () => {
  try {
    const response = await axios.get(urlPath);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const getAlmacen = async (id) => {
  try {
    const response = await axios.get(`${urlPath}/${id}`);

    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const deleteAlmacen = async (id) => {
    console.log(id)
  try {
    const response = await axios.delete(`${urlPath}/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};
export const updateAlmacen = async (id, data) => {
  try {
    const response = await axios.put(`${urlPath}/${id}`, data);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};